import { CouponCurrencyType } from 'app/main/design-system/models/coupon.type';
import { NotificationType } from '../communicationCampaign/campaign.type';

export enum MarketingType {
  BIRTHDAY = 'BIRTHDAY',
  LOST_CUSTOMER = 'LOST_CUSTOMER',
  NEW_CUSTOMER = 'NEW_CUSTOMER',
}

export interface MarketingRevenueDTO {
  id: string;
  isActive: boolean;
  marketingType: MarketingType;
  /** CA estimated */
  revenue: number;
  /** Number of people which are generated CA */
  openedPercent: number;
  /** Number of people who have been targeted by the notification */
  nbNotificationsSent?: number;
  /** Number of people who have been successfully targeted by the notification */
  nbNotificationsSuccessfullySent?: number;
  /** % people who have read information */
  nbConvertedUsers: number;
  /** % of people which are generated CA */
  conversionPercent: number;
  /** Number of coupons generated (if coupon) */
  nbCouponsGenerated?: number;
  currencyCode: CouponCurrencyType;
  communicationCampaignAverageBasket: number;
  communicationCampaignType: NotificationType;
}

export interface MarketingDTO {
  id: string;
  dateCreated: string;
  lastModified: string;
  isActive: boolean;
  communicationCampaignAverageBasket: number;
  communicationCampaignType: NotificationType;
  marketingType: MarketingType;
  name: string;
  userId: string;
  franchiseId: string;
  currentCommunicationCampaignId: string;
  communicationCampaignIds: string[];
  /** Birthday only: lead time of the send, "7D" or "2W" */
  sendBefore?: string;
}

export interface MarketingWithRevenueDTO extends MarketingDTO {
  totalMarketingRevenue?: MarketingRevenueDTO;
  isTotalRevenueLoading?: boolean;
  isTotalRevenueError?: boolean;
}
